export const MF_NAME = import.meta.env.VITE_RUNTIME_MF_NAME || 'guide-author-mfe';
